<template>
  <div class="banner__tab tab">
    <div class="tab__center">
      <h2>{{ $t("VUE.STATS") }}</h2>
      <div class="tab__chart" v-if="loading">
        <Loader />
      </div>
      <div class="tab__chart" v-else>
        <div class="tab__chart-labels">
          <div
            class="tab__chart-label"
            v-for="({ label, color }, index) in labels"
            :key="index"
          >
            <div :style="`background-color: ${color}`"></div>
            <small>{{ $t(label) }}</small>
          </div>
        </div>
        <div class="tab__chart-wrap">
          <canvas class="tab__chart" ref="stats"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Chart from "chart.js";

export default {
  name: "ProjectBannerChartTab",
  data() {
    return {
      labels: [
        { label: "VUE.CHART.PROCESSED", color: "rgba(51, 102, 204, .9)" },
        { label: "VUE.CHART.PENDING", color: "rgba(220, 57, 18, .9)" },
        { label: "VUE.CHART.REJECTED", color: "rgba(255, 153, 0, .9)" },
        { label: "VUE.CHART.ONCHECK", color: "rgba(16, 150, 24, .9)" },
        { label: "VUE.CHART.HELPCONFIRMED", color: "rgba(153, 0, 153, .9)" }
      ],
      chart: {
        labels: [
          this.$t("VUE.CHART.PROCESSED"),
          this.$t("VUE.CHART.PENDING"),
          this.$t("VUE.CHART.REJECTED"),
          this.$t("VUE.CHART.ONCHECK"),
          this.$t("VUE.CHART.HELPCONFIRMED")
        ],
        backgroundColor: [
          "rgba(51, 102, 204, .9)",
          "rgba(220, 57, 18, .9)",
          "rgba(255, 153, 0, .9)",
          "rgba(16, 150, 24, .9)",
          "rgba(153, 0, 153, .9)"
        ],
        borderWidth: 0,
        options: {
          maintainAspectRatio: false,
          legend: {
            display: false
          }
        }
      },
      loading: true
    };
  },
  computed: {
    ...mapGetters(["chartData"])
  },
  methods: {
    ...mapActions(["fetchChartData"])
  },
  async mounted() {
    this.$route.name === "helpcenter.project"
      ? await this.fetchChartData(
          `${this.$route.path}/${this.$route.meta.langs[0].locale}`
        ).then(() => (this.loading = false))
      : null;

    Chart.defaults.global.defaultFontFamily = "'Nunito', sans-serif";
    if (this.chartData) {
      new Chart(this.$refs.stats, {
        type: "pie",
        data: {
          labels: this.chart.labels,
          datasets: [
            {
              data: this.chartData,
              backgroundColor: this.chart.backgroundColor,
              borderWidth: this.chart.borderWidth
            }
          ]
        },
        options: this.chart.options
      });
    }
  },
  beforeDestroy() {
    Chart && Chart.destroy ? Chart.destroy() : null;
  },
  components: {
    Loader: () => import("@/components/app/Loader")
  }
};
</script>
